export default __webpack_public_path__ + "029f6eff2d7dd4bcadc02218153673b4.png";